import noteActionTypes from "./notes.types";

export const setNotes = (notes) => ({
  type: noteActionTypes.SET_NOTES,
  payload: notes,
});
